module.exports = __webpack_public_path__ + "img/yellowcheck.9f16a2b7.png";